import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes, valueItems } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Sections 10 + 11 — everything included and what it would take to build yourself. */
export function LibrarySection() {
  return <section aria-labelledby="library-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-144" data-mp="1ai72o1u6eayz">
      <div className="mx-auto max-w-6xl" data-id="element-145" data-mp="1f96zz877iv20">
        <SectionHeading id="library-heading" eyebrow="Everything You Get" title={<>
              One Nail Educator Library. <Accent data-id="element-147" data-mp="16fu0fnen0v6y">Ready When You Need It.</Accent>
            </>} data-id="element-146" data-mp="1fa8a9agefdio" />

        <div className="mt-12 grid items-center gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-148" data-mp="rjcq8zi6pmlz">
          <img src={MOCKUP_URL} alt="The six Nail Educator Ready volumes included in the bundle" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[560px] object-contain lg:max-w-none" style={{
          filter: 'drop-shadow(0 28px 32px rgba(120, 96, 56, 0.22))'
        }} data-id="element-149" data-mp="whwc6zws2yec" />

          <ul className="grid gap-x-6 gap-y-3 rounded-[20px] bg-brand-ivory px-6 py-7 sm:grid-cols-2 sm:px-8" role="list" data-id="element-150" data-mp="3n7xk8su1yo81">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-snug text-brand-charcoal" data-id="element-151" data-mp="2zgiculnf5gpx">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-152" data-mp="38b6i4bszuyeq" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-153" data-mp="2fuvp42dgza4f">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-154" data-mp="2ft2kesmf2zz2">
            Complete Nail Educator System
          </p>
          <h3 className="mt-4 font-display text-[1.9rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[2.3rem]" data-id="element-155" data-mp="etfqkjrg8xfv">
            Build Your Classes Without Building Everything From Scratch.
          </h3>
          <p className="mt-4 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-156" data-mp="ojii0fixa3c3">
            Think about how much time it would take to independently create:
          </p>
          <ul className="mx-auto mt-5 flex max-w-lg flex-wrap justify-center gap-2.5" role="list" data-id="element-157" data-mp="3rzfuww8gxpe4">
            {valueItems.map(item => <li key={item} className="rounded-full border border-brand-charcoal/15 bg-brand-ivory px-3.5 py-1.5 font-body text-[12px] text-brand-charcoal/75" data-id="element-158" data-mp="to9ub9jt2y6">
                {item}
              </li>)}
          </ul>
          <p className="mt-6 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-159" data-mp="1h7xuauao67jq">
            You don't need to create all of that before your next class.
          </p>

          <CtaBlock label="Get Nail Educator Ready™" meta="Instant Access • 6 Volumes • 5 Bonuses • Ready-to-Use PDFs" className="mx-auto mt-9 max-w-md" data-id="element-160" data-mp="36oa5hxbkj791" />
        </div>
      </div>
    </section>;
}